<script>
  export default {
    props: {
      list: {
        type: Object,
        required: true
      }
    },
  }
</script>
<template>
  <div :class="$style.footerMenuList">
    <div class="text-gray-7 title mt-2">{{ list.title }}</div>
    <div class="d-flex flex-column footerMenuInner">
      <template v-for="(item,$index) in list.list">
        <router-link
          v-if="item.path"
          :key="$index"
          :to="item.path"
          class="footerMenuItem"
        >
          {{ item.title }}
        </router-link>
        <a
          v-else
          :key="$index"
          :href="item.href"
          class="footerMenuItem"
        >
          {{ item.title }}
        </a>
      </template>
      
    </div>
  </div>
</template>

<style lang="scss" module>
  .footerMenuList {
    :global {
      .footerMenuInner {
        margin-top: 57px;

        @include max-md {
          margin-top: 1.5rem;
        }
      }

      .title {
        font-size: 20px;
        font-weight: 500;

        @include max-md {
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 0;
        }
      }

      .footerMenuItem {
        color: $color-gray-6;
        text-decoration: none;
        transition: .3s;

        @include max-md {
          font-size: 14px;
        }

        &:hover {
          color: $color-primary;
        }

        &:not(:last-child) {
          margin-bottom: 15px;
        }

        &.router-link-exact-active {
          color: $color-primary;
        }
      }
    }
  }
</style>
